var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Utils, CustomElement, Watch, ViewChild, PropertyConverters, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemPictureSourceElement = class PacemPictureSourceElement extends Components.PacemItemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        const picture = this.container;
        if (picture instanceof PacemPictureElement && ['srcset', 'media', 'type', 'disabled'].indexOf(name) >= 0) {
            picture.refreshSources();
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemPictureSourceElement.prototype, "srcset", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemPictureSourceElement.prototype, "media", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemPictureSourceElement.prototype, "type", void 0);
PacemPictureSourceElement = __decorate([
    CustomElement({
        tagName: P + '-picture-source'
    })
], PacemPictureSourceElement);
export { PacemPictureSourceElement };
let PacemPictureElement = class PacemPictureElement extends Components.PacemItemsContainerElement {
    constructor() {
        super('img', { 'label': 'picture' });
        this._updateCurrentSrcHandler = (evt) => {
            this.currentSrc = this._img.currentSrc;
        };
    }
    validate(item) {
        return item instanceof PacemPictureSourceElement;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'src':
                this._setSource();
                break;
            case 'items':
                this._setSources();
                break;
            case 'tooltip':
                this._setAltText();
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._img.addEventListener('load', this._updateCurrentSrcHandler, false);
        this._setSource();
        this._setAltText();
        this._setSources();
    }
    disconnectedCallback() {
        const img = this._img;
        if (!Utils.isNull(img)) {
            img.removeEventListener('load', this._updateCurrentSrcHandler, false);
        }
        super.disconnectedCallback();
    }
    refreshSources() {
        this._setSources();
    }
    _setSources(items = this.items) {
        const picture = this._picture, img = this._img;
        if (!Utils.isNull(picture) && !Utils.isNull(img)) {
            const sources = picture.querySelectorAll('source'), itemCount = items?.length ?? 0;
            // populate
            for (let i = 0; i < itemCount; i++) {
                const item = this.items[i];
                let source;
                if (sources.length <= i) {
                    source = document.createElement('source');
                    source.setAttribute('part', 'source');
                    picture.insertBefore(source, img);
                }
                else {
                    source = sources.item(i);
                }
                if (item.disabled || Utils.isNullOrEmpty(item.srcset)) {
                    source.removeAttribute('srcset');
                }
                else {
                    source.srcset = item.srcset;
                }
                if (Utils.isNullOrEmpty(item.media)) {
                    source.removeAttribute('media');
                }
                else {
                    source.media = item.media;
                }
                if (Utils.isNullOrEmpty(item.type)) {
                    source.removeAttribute('type');
                }
                else {
                    source.type = item.type;
                }
            }
            // cleanup
            for (let i = sources.length - 1; i >= itemCount; i--) {
                let source = sources.item(i);
                source.remove();
            }
        }
    }
    _setSource(src = this.src) {
        const img = this._img;
        if (!Utils.isNull(img)) {
            if (Utils.isNullOrEmpty(src)) {
                img.removeAttribute('src');
            }
            else {
                img.src = src;
            }
        }
    }
    _setAltText(tip = this.tooltip) {
        const img = this._img;
        if (!Utils.isNull(img)) {
            if (Utils.isNullOrEmpty(tip)) {
                img.alt = this.aria.attributes.toObject()['label'];
            }
            else {
                img.alt = tip;
            }
        }
    }
};
__decorate([
    ViewChild('picture')
], PacemPictureElement.prototype, "_picture", void 0);
__decorate([
    ViewChild('img')
], PacemPictureElement.prototype, "_img", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemPictureElement.prototype, "src", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemPictureElement.prototype, "currentSrc", void 0);
PacemPictureElement = __decorate([
    CustomElement({
        tagName: P + '-picture', shadow: true,
        template: `<picture part="picture"><img loading="lazy" part="img" /></picture><slot></slot>`
    })
], PacemPictureElement);
export { PacemPictureElement };
